import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { fetchWorkshopTypes } from '../../apis/workshopTypeApi';
import { IWorkshopType } from '../../interface/Workshop';

export const useFetchWorkshopTypes = (
    searchQuery: string,
    currentPage: number,
    itemsPerPage: number
) => {
    return useQuery<{ data: IWorkshopType[]; totalItems: number }, Error>(
        ['workshopTypes', searchQuery, currentPage],
        () => fetchWorkshopTypes(searchQuery, currentPage, itemsPerPage),
        {
            keepPreviousData: true,
            onError: (error) => {
                toast.error(error.message || 'An unexpected error occurred while fetching workshop types.');
            },
        }
    );
};
